// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ratio {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 6px;
  overflow: hidden;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
  border-radius: inherit;
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}
.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}
.ratio-21x9 {
  --bs-aspect-ratio: 42.857143%;
}
.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}
.Video {
  width: 100%;
  max-width: 100%;
  border-radius: 6px;
  object-fit: cover;
}
/*# sourceMappingURL=Video.css.map */`, "",{"version":3,"sources":["webpack://./Video.less","webpack://./wp_components/Video/Video.less"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;ACDJ;ADGI;EACI,cAAA;EACA,mCAAA;EACA,WAAA;EACA,sBAAA;ACDR;ADVA;EAeQ,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;ACFR;ADMA;EACI,yBAAA;ACJJ;ADMA;EACI,sBAAA;ACJJ;ADMA;EACI,6BAAA;ACJJ;ADMA;EACI,uBAAA;ACJJ;ADOA;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ACLJ;AACA,oCAAoC","sourcesContent":["@import \"../../less/variables.less\";\n\n.ratio {\n    position: relative;\n    width: 100%;\n    margin-bottom: 10px;\n    border-radius: @radius-sm;\n    overflow: hidden;\n\n    &::before {\n        display: block;\n        padding-top: var(--bs-aspect-ratio);\n        content: \"\";\n        border-radius: inherit;\n    }\n\n    > * {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n    }\n}\n\n.ratio-16x9 {\n    --bs-aspect-ratio: 56.25%;\n}\n.ratio-4x3 {\n    --bs-aspect-ratio: 75%;\n}\n.ratio-21x9 {\n    --bs-aspect-ratio: 42.857143%;\n}\n.ratio-1x1 {\n    --bs-aspect-ratio: 100%;\n}\n\n.Video {\n    width: 100%;\n    max-width: 100%;\n    border-radius: @radius-sm;\n    object-fit: cover;\n}\n\n\n",".ratio {\n  position: relative;\n  width: 100%;\n  margin-bottom: 10px;\n  border-radius: 6px;\n  overflow: hidden;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n  border-radius: inherit;\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.857143%;\n}\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n.Video {\n  width: 100%;\n  max-width: 100%;\n  border-radius: 6px;\n  object-fit: cover;\n}\n/*# sourceMappingURL=Video.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
